interface CheckSquareIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const CheckSquareIcon = ({ color = 'currentColor', size = '64', className, ...props }: CheckSquareIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M54 18.6667C54 13.8802 50.1198 10 45.3333 10H18.6667C13.8802 10 10 13.8802 10 18.6667V45.3333C10 50.1198 13.8802 54 18.6667 54H45.3333C50.1198 54 54 50.1198 54 45.3333V18.6667ZM58 45.3333C58 52.3289 52.3289 58 45.3333 58H18.6667C11.6711 58 6 52.3289 6 45.3333V18.6667C6 11.6711 11.6711 6 18.6667 6H45.3333C52.3289 6 58 11.6711 58 18.6667V45.3333Z"
      fill={color}
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.1625 24.3727C42.0613 25.0147 42.2695 26.2638 41.6275 27.1626L31.6275 41.1626C31.2858 41.641 30.7509 41.9449 30.165 41.9933C29.5791 42.0418 29.0015 41.8301 28.5858 41.4144L22.5858 35.4144C21.8047 34.6333 21.8047 33.367 22.5858 32.5859C23.3668 31.8049 24.6332 31.8049 25.4142 32.5859L29.7448 36.9165L38.3725 24.8377C39.0146 23.9389 40.2637 23.7307 41.1625 24.3727Z"
      fill={color}
    />
  </svg>
);
